module.exports = __webpack_public_path__ + "media/images/empty-pencil-b9a2f9ba.svg";